/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import AppPrivacy_Section1 from "./sections/AppPrivacy_Section1";

function AppPrivacy() {
  usePageMeta({
    title: "App Privacy Policy | Spechs Workforce",
    description:
      "Privacy policy for the Spechs Workforce mobile app. Learn how we handle your data.",
    canonical: "https://www.spechs.ie/app-privacy/",
  });
  return (
    <SubPageLayout title="Mobile App Privacy Policy">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <AppPrivacy_Section1 />
      </MKBox>
    </SubPageLayout>
  );
}

export default AppPrivacy;
